export const transition = {
    duration: .25,
    ease: [.56, .03, .12, 1.04]
};


export const variants = {
    hide: {
        opacity: 0
    },
    show: {
        opacity: 1
    }
};